import React from 'react';
import { ClientWebEmbeddingMessage, ClientWebEmbeddingMessageType } from '@youhelp-ru/common/clientWebEmbedding';
import { coreApi } from '@cp/shared/api/core';
import { CoreDialogApiTags } from '@cp/entities/dialog';
import { ApiTags } from '@cp/shared/api/core/const';
import { useDispatch } from 'react-redux';
import { embeddingSlice } from 'src/shared/embedding';
import { useOutgoingMessageTriggers } from './triggers';
import { IEmbeddingMessagesProps } from './types';

export * from './initializeEmbedding';

export const useEmbeddingMessages = (props: IEmbeddingMessagesProps) => {
  const [isRecipientReady, setRecipientReady] = React.useState(false);
  const dispatch = useDispatch();

  useOutgoingMessageTriggers({ ...props, isRecipientReady });

  const handleMessage = React.useCallback(
    (message: ClientWebEmbeddingMessage) => {
      if (message.type === ClientWebEmbeddingMessageType.Ready) {
        setRecipientReady(true);
        return;
      }

      if (message.type === ClientWebEmbeddingMessageType.ComeToForeground) {
        dispatch(
          coreApi.util.invalidateTags([
            CoreDialogApiTags.DialogList,
            CoreDialogApiTags.Dialog,
            CoreDialogApiTags.Messages,
            CoreDialogApiTags.UnreadMessagesCount,
          ] as unknown as ApiTags[]),
        );
        return;
      }

      if (message.type === ClientWebEmbeddingMessageType.SharedStateUpdated) {
        dispatch(embeddingSlice.actions.updateSharedState(message.stateUpdate));
        return;
      }
      // TODO: handle other messages
    },
    [dispatch],
  );

  return handleMessage;
};
